var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import RolesAutocomplete from '@/components/Autocompletes/RolesAutocomplete/RolesAutocomplete';
import EditableCard from '@/components/EditableCard/EditableCard';
import { GlobalUser, GlobalUserIncludes } from '@/models/GlobalUser';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue } from 'vue-property-decorator';
import LabelValue from '@/components/LabelValue.vue';
import { fileToBase64 } from '@/support/String';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import Roles, { RolesEnum } from '@/items/Roles';
import DataTable from '@/components/data-table/DataTable';
import AddSchoolDialog from '@/components/AddSchoolDialog/AddSchoolDialog';
let User = class User extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        // Use getter and setter to update this prop
        this.internalUser = null;
        this.userClone = null;
        this.isLoading = true;
        this.isEditing = false;
        this.isChangingAvatar = false;
        this.isAddingSchool = false;
        this.baseImage = null;
        this.password = '';
        this.passwordConfirm = '';
        this.role = null;
        this.acceptedValues = [
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.RESELLER,
        ];
        // protected get userIsReseller(): boolean {
        //   if (!this.internalUser) {
        //     return false;
        //   }
        //   return this.internalUser.roles.some((role: Role) => role.id === 'reseller');
        // }
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        this.user = await this.fetchUser();
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    globalUserModel(attrs = {}) {
        return new GlobalUser(attrs)
            .include([
            GlobalUserIncludes.TOKEN,
            GlobalUserIncludes.SCHOOLS,
        ]);
    }
    async fetchUser() {
        return this.globalUserModel()
            .find(this.$route.params.id);
    }
    onIsEditing(isEditing) {
        this.isEditing = isEditing;
        if (!isEditing) {
            // this.fetchJob();
        }
    }
    onSchoolAdded() {
        this.initialize();
    }
    onImageChanged(imageUrl) {
        if (this.userClone) {
            this.userClone.avatar = imageUrl;
        }
        this.isChangingAvatar = false;
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        const file = event.target.files[0];
        fileToBase64(file)
            .then((encodedFile) => {
            if (!this.userClone) {
                return;
            }
            this.userClone.avatar = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const userWithDataObjects = await new GlobalUser()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (userWithDataObjects) {
            this.baseImage = userWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
    }
    generatePayload() {
        if (!this.userClone) {
            return {};
        }
        const payload = {
            avatar: this.userClone.avatar,
            email: this.userClone.email,
            first_name: this.userClone.first_name,
            middle_name: this.userClone.middle_name,
            last_name: this.userClone.last_name,
            roles: this.role && this.role.id ? [this.role.id] : [this.role],
        };
        if (this.password && this.password === this.passwordConfirm) {
            payload.password = this.password;
        }
        return payload;
    }
    passwordMatch() {
        return (this.password === this.passwordConfirm ? true : 'The email and password you entered don\'t match');
    }
    loginAs() {
        if (!this.$store.state.Auth.hasRole([RolesEnum.ROOT])) {
            return;
        }
        if (!this.user) {
            return;
        }
        this.user.impersonate();
    }
    onClickAddSchool() {
        this.isAddingSchool = true;
    }
    onClickDelete(id) {
        this.$store.dispatch('openDialog', this.deleteDialogOptions(id));
    }
    deleteDialogOptions(id) {
        return {
            title: this.$tc('dialogOptions.confirmation'),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.school') }),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: async () => {
                        if (!id) {
                            return;
                        }
                        const schools = this.userClone.schools
                            .filter((school) => school.id !== id)
                            .map((school) => school.id);
                        this.user = await this.updateUser({ schools })
                            .catch((error) => {
                            ErrorHandler.network(error);
                            return this.userClone;
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    onDeleteUserButtonClick() {
        this.$store.dispatch('openDialog', this.getConfirmDeleteUserDialogOptions());
    }
    getConfirmDeleteUserDialogOptions() {
        return {
            title: this.$tc('dialogOptions.confirmation'),
            text: this.$tc('dialogOptions.delete', 2, { item: this.user && this.user.rolesLabel ? this.user.rolesLabel : this.$t('dialogOptions.item.user') }),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: async () => {
                        await this.deleteUser();
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    // #endregion
    // #region Async methods
    async onSave(event) {
        const payload = this.generatePayload();
        const isValid = true; // TODO VALIDATE!!
        if (!payload || !isValid) {
            event.setFailedState();
            return;
        }
        const updatedUser = await this.updateUser(payload);
        if (updatedUser) {
            this.user = updatedUser;
            event.setSuccessState();
            return;
        }
        event.setFailedState();
    }
    async deleteUser() {
        try {
            await this.globalUserModel({ id: this.$route.params.id })
                .delete();
            this.$router.replace({ name: 'users' });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async updateUser(payload) {
        try {
            const result = await this.globalUserModel({ id: this.$route.params.id })
                .update(payload);
            return result;
        }
        catch (error) {
            ErrorHandler.network(error);
            return null;
        }
    }
    // #endregion
    // #region Getters & Setters
    get user() {
        return this.internalUser;
    }
    set user(user) {
        this.internalUser = user;
        this.userClone = user ? user.clone() : null;
        this.role = this.userClone && this.userClone.roles[0] || null;
    }
    get breadcrumbs() {
        return [
            { name: 'Users', path: '/admin/users' },
            { name: (this.user && this.user.name) || '' }
        ];
    }
    get items() {
        // we only use 1 role in school. if we were to change that, this will brake
        const userRole = this.$store.state.Auth.roles[0];
        return Roles.roleBasedVisibleItems(userRole.id)
            .filter((item) => this.acceptedValues.includes(item.id));
    }
    get canLoginAs() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT]) && !this.isSelf;
    }
    get canUpdateRole() {
        if (!this.user) {
            return false;
        }
        if (this.globalUser.hasRole([RolesEnum.ROOT])) {
            // root can update roles of self, not other root users
            if (!this.isSelf && (this.user.hasRole([RolesEnum.ROOT]))) {
                return false;
            }
        }
        if (this.globalUser.hasRole([RolesEnum.ADMIN])) {
            // admins cannot update their own role
            if (this.isSelf) {
                return false;
            }
            // admins can update roles of resellers and other admins
            if (this.user.hasRole([RolesEnum.ROOT])) {
                return false;
            }
        }
        if (!this.globalUser.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT])) {
            return false;
        }
        return true;
    }
    get isDeleteUserButtonVisible() {
        if (!this.user) {
            return false;
        }
        // prevent deletion of self
        if (this.$store.state.Auth.id === this.user.id) {
            return false;
        }
        // root can delete any
        if (this.$store.state.Auth.hasRole([RolesEnum.ROOT])) {
            return true;
        }
        // admin can only delete other than root or admin
        if (this.$store.state.Auth.hasRole([RolesEnum.ADMIN]) && !this.user.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN])) {
            return true;
        }
        // the rest cannot delete any
        return false;
    }
    get isSelf() {
        return !!this.user && this.user.isSameAs(this.$store.state.Auth);
    }
    get globalUser() {
        return this.$store.state.Auth;
    }
    get canAddSchool() {
        return this.globalUser.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get tableHeaders() {
        return [
            { text: 'Naam', value: 'id' },
            { text: '', value: 'actions', width: '50px', align: 'right' },
        ];
    }
    get isEditingDisabled() {
        if (this.loggedInAsSuperUser) {
            return false;
        }
        if (this.loggedInAsReseller && (this.userIsAdmin || this.userIsSuperUser)) {
            return true;
        }
        if (this.loggedInAsAdmin && this.userIsSuperUser) {
            return true;
        }
        return false;
    }
    get loggedInAsSuperUser() {
        return this.$store.state.Auth.roles.some((role) => role.id === 'root');
    }
    get loggedInAsAdmin() {
        return this.$store.state.Auth.roles.some((role) => role.id === 'administrator');
    }
    get loggedInAsReseller() {
        return this.$store.state.Auth.roles.some((role) => role.id === 'reseller');
    }
    get userIsSuperUser() {
        if (!this.internalUser) {
            return false;
        }
        return this.internalUser.roles.some((role) => role.id === 'root');
    }
    get userIsAdmin() {
        if (!this.internalUser) {
            return false;
        }
        return this.internalUser.roles.some((role) => role.id === 'administrator');
    }
    get isDeleteIconVisible() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
};
User = __decorate([
    Component({
        components: {
            RolesAutocomplete,
            EditableCard,
            LabelValue,
            ImageInput,
            AddSchoolDialog,
            DataTable,
        },
    })
], User);
export default User;
